import { render } from "./MessageAction.vue?vue&type=template&id=52c11e64"
import script from "./MessageAction.vue?vue&type=script&lang=js"
export * from "./MessageAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__